export default __webpack_public_path__ + "static/media/crosss.80737611.png";